/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierCommitmentHistory.ts      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/carrier-commitment-history";

export class AutogenModelCarrierCommitmentHistory<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierCommitmentHistoryFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCarrierCommitmentHistory extends ModelRow<RowCarrierCommitmentHistoryFields> {
	constructor(values?: Partial<RowCarrierCommitmentHistoryFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCarrierCommitmentHistoryFields {
	carrier_lane_rate_id: string;
	company_id: string;
	date_met: Date;
	date_offered: Date;
	delivery_date: Date;
	id: string;
	movement_id: string;
	offers_sent: number;
	order_id: string;
	pickup_date: Date;
	rate: string;
	rate_type: string;
}

